import React from 'react'
import { Chip, ChipProps } from '@mui/material'

export type WorkOrderStatus = 'DRAFT' | 'IN_PROGRESS' | 'COMPLETED' | 'CANCELLED'

interface WorkOrderStatusChipProps {
  status: WorkOrderStatus
  size?: ChipProps['size']
  variant?: ChipProps['variant']
}

const WorkOrderStatusChip: React.FC<WorkOrderStatusChipProps> = ({
  status,
  size = 'small',
  variant = 'filled',
}) => {
  const getStatusConfig = (status: WorkOrderStatus) => {
    switch (status) {
      case 'DRAFT':
        return {
          label: 'Draft',
          color: 'default' as const,
          backgroundColor: '#f5f5f5',
          textColor: '#666',
        }
      case 'IN_PROGRESS':
        return {
          label: 'In Progress',
          color: 'primary' as const,
          backgroundColor: '#e3f2fd',
          textColor: '#1976d2',
        }
      case 'COMPLETED':
        return {
          label: 'Completed',
          color: 'success' as const,
          backgroundColor: '#e8f5e8',
          textColor: '#2e7d32',
        }
      case 'CANCELLED':
        return {
          label: 'Cancelled',
          color: 'error' as const,
          backgroundColor: '#ffebee',
          textColor: '#d32f2f',
        }
      default:
        return {
          label: status,
          color: 'default' as const,
          backgroundColor: '#f5f5f5',
          textColor: '#666',
        }
    }
  }

  const config = getStatusConfig(status)

  return (
    <Chip
      label={config.label}
      size={size}
      variant={variant}
      sx={{
        backgroundColor: config.backgroundColor,
        color: config.textColor,
        fontWeight: 'medium',
        '& .MuiChip-label': {
          color: config.textColor,
        },
      }}
    />
  )
}

export default WorkOrderStatusChip 